<div class="breadcrumb">
    <span *ngFor="let element of elements; let last = last">
        <span [routerLink]="element.route" *ngIf="element.translate" class="breadcrumb-link" [ngClass]="{'breadcrumb-disabled': !last}">{{'BREADCRUMB.'+element.name | translate}}</span>
        <span [routerLink]="element.route" *ngIf="!element.translate" class="breadcrumb-link" [ngClass]="{'breadcrumb-disabled': !last}">{{element.name}}</span>
        <span *ngIf="!last" class="breadcrumb-disabled"> / </span>
    </span>
</div>